// Publish the core libraries the legacy app and the vendored jQuery plugins
// reach for as window globals (underscore, moment, i18n-js).
//
// This is a side-effect module so the `window.X = X` assignments run *during*
// module evaluation, in import order. That matters because ES module imports are
// all evaluated before the importing module's body: a vendored plugin like
// daterangepicker ends with `}(window.jQuery, window.moment)` and reads
// window.moment at load time, so if we set window.moment in the studio-vendor
// body (after the imports) it is still undefined when daterangepicker evaluates
// ("t is not a function", where t is its `moment` parameter). Importing this
// module before those plugins guarantees the globals exist first.
import _ from "underscore";
import moment from "moment";
import i18n from "./i18n_instance";

window._ = _;
window.moment = moment;
window.I18n = i18n;
